import type { SelectOption } from '../../../components/inputs/Select';
import { particularsSuggestions } from '../particularsSuggestions';

/*
  Plausible wording rather than obviously synthetic values: nothing here lands in the identity
  store — the requester is an existing employee picked from the LIVE list, never a name the
  generator invents.
*/
const PARTICULARS = [
  'Reimbursement of training registration fee and transportation.',
  'Payment of electricity bill for the month.',
  'Release of employee welfare benefit.',
  'Purchase of office supplies charged to operational expenses.',
  'Fidelity bond premium for accountable officers.',
  'Issuance of cheque for supplier payment.',
];

function pick<T>(items: readonly T[]): T | undefined {
  return items.length === 0 ? undefined : items[Math.floor(Math.random() * items.length)];
}

/**
 * A request filled from the LIVE pickers, so every foreign key is a row the server accepts.
 * A picker that has not loaded leaves its field empty rather than inventing an id.
 */
export function sampleDisbursementRequest(options: {
  staff: SelectOption[];
  transactionTypes: SelectOption[];
  paymentTypes: SelectOption[];
}): {
  requesterPersonnelId: string | null;
  transactionTypeId: string | null;
  paymentTypeId: string | null;
  items: { particulars: string; amount: number }[];
  notes: string;
} {
  const transactionType = pick(options.transactionTypes);

  /*
    The lines read from the SAME suggestions the form offers for the type it picked, so a sample
    Bills request says "Electricity" rather than a sentence about another type. A type with no
    suggestions falls back to the general sentences below.
  */
  const suggested = particularsSuggestions(transactionType?.label);
  const vocabulary = suggested.length > 0 ? suggested : PARTICULARS;

  // Two or three lines, so the total under the grid has something to add up.
  const count = 2 + Math.floor(Math.random() * 2);
  const items = Array.from({ length: count }, () => ({
    particulars: pick(vocabulary) ?? PARTICULARS[0],
    amount: Math.round((500 + Math.random() * 19_500) * 100) / 100,
  }));

  return {
    requesterPersonnelId: pick(options.staff)?.value ?? null,
    transactionTypeId: transactionType?.value ?? null,
    paymentTypeId: pick(options.paymentTypes)?.value ?? null,
    items,
    notes: 'Sample request. Delete it once the real ones are in.',
  };
}
